import { render } from "./lazy-pagination.vue?vue&type=template&id=e8ed1c1e&ts=true"
import script from "./lazy-pagination.vue?vue&type=script&lang=ts"
export * from "./lazy-pagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__